// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkComponent_link__3Qd0e","icon":"LinkComponent_icon__vxlnh"};